import React, { useState } from 'react';

const TermsConditions = () => {
  const [activeTab, setActiveTab] = useState('terms');

  return (
    <div className="min-h-screen mt-28 bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Hero Section */}
      <div className="relative bg-white shadow-lg">
        <div className="absolute inset-0 bg-gradient-to-r from-blue-600 to-indigo-600 opacity-90"></div>
        <div className="relative max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-white text-center mb-4">
            Terms & Conditions
          </h1>
          <p className="text-xl text-blue-100 text-center max-w-3xl mx-auto">
            Please read these terms carefully before proceeding with registration or product purchase
          </p>
          <div className="flex justify-center mt-8 space-x-4">
            <button
              onClick={() => setActiveTab('terms')}
              className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${
                activeTab === 'terms'
                  ? 'bg-white text-blue-600 shadow-lg'
                  : 'bg-blue-700 text-white hover:bg-blue-500'
              }`}
            >
              Terms & Conditions
            </button>
            <button
              onClick={() => setActiveTab('agreement')}
              className={`px-6 py-2 rounded-lg font-semibold transition-all duration-300 ${
                activeTab === 'agreement'
                  ? 'bg-white text-blue-600 shadow-lg'
                  : 'bg-blue-700 text-white hover:bg-blue-500'
              }`}
            >
              Distributor Agreement
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        {activeTab === 'terms' ? (
          <div className="space-y-6">
            {/* Section 1 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-blue-500 to-blue-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">1. Definition of the Company</h2>
              </div>
              <div className="p-6">
                <p className="text-gray-700 leading-relaxed">
                  This company is a registered Private Limited (Pvt. Ltd.) entity engaged solely in the manufacturing, sale, and distribution of products and services.
                  The company does not operate any Fixed Return Scheme, Money Circulation Scheme, or Investment Plan of any kind.
                </p>
              </div>
            </div>

            {/* Section 2 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-green-500 to-green-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">2. Membership (Distributor Registration)</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Any individual can become a Distributor/Partner of the company only after completing the registration process.</li>
                  <li>For registration, submission of Aadhaar Card, PAN Card, Bank Account details, and Address Proof is mandatory.</li>
                  <li>Each Distributor will be provided with a unique Distributor ID and Login Access.</li>
                </ul>
              </div>
            </div>

            {/* Section 3 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-purple-500 to-purple-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">3. Product Purchase & Sales</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>All commissions and income are strictly based on product sales and repurchase.</li>
                  <li>At the time of joining, the Distributor may only purchase a Product Kit.</li>
                  <li>No income shall be generated without product purchase or sales.</li>
                </ul>
              </div>
            </div>

            {/* Section 4 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-orange-500 to-orange-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">4. Commission & Payment Policy</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>The company's Commission Structure (Direct Income, Matrix Level Income, Generation Income, Matching Bonus, Royalty, etc.) is based solely on Business Volume (BV).</li>
                  <li>Applicable taxes (TDS 5% and GST, as per government rules) will be deducted from all payouts.</li>
                  <li>Commission payments will be made via Wallet or Bank Transfer.</li>
                  <li>Minimum withdrawal limit: ₹200.</li>
                </ul>
              </div>
            </div>

            {/* Section 5 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-red-500 to-red-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">5. Refund / Return / Buy-Back Policy</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Distributors may return purchased products within 7 days, provided the products are unused and undamaged.</li>
                  <li>Refunds will be processed through the same payment method used at the time of purchase.</li>
                </ul>
              </div>
            </div>

            {/* Section 6 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-pink-500 to-pink-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">6. Duties of the Distributor</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>The Distributor must provide accurate and truthful information to customers.</li>
                  <li>Any false promises, guaranteed income claims, investment offers, or mis-selling practices are strictly prohibited.</li>
                  <li>The Distributor may promote only the company-approved products and business plan.</li>
                </ul>
              </div>
            </div>

            {/* Section 7 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-indigo-500 to-indigo-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">7. Rights of the Company</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>If any Distributor violates the rules, the company reserves the right to terminate their membership immediately.</li>
                  <li>The company reserves the right to modify its Business Plan, Commission Structure, and Terms & Conditions at any time.</li>
                </ul>
              </div>
            </div>

            {/* Section 8 */}
            <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="bg-gradient-to-r from-teal-500 to-teal-600 px-6 py-3">
                <h2 className="text-xl font-bold text-white">8. Compliance with Consumer Protection Rules, 2021</h2>
              </div>
              <div className="p-6">
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>The company operates in compliance with the Direct Selling Rules, 2021 issued by the Government of India.</li>
                  <li>The company does not promote or operate any Pyramid Scheme or Money Circulation Scheme.</li>
                  <li>All disputes shall be subject to the jurisdiction of the registered office location (Prayagraj, Uttar Pradesh).</li>
                </ul>
              </div>
            </div>
          </div>
        ) : (
          <div className="space-y-6">
            {/* Distributor Agreement */}
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 rounded-xl shadow-xl overflow-hidden">
              <div className="px-6 py-4 bg-gradient-to-r from-amber-500 to-orange-500">
                <h2 className="text-2xl font-bold text-white text-center">Distributor Agreement</h2>
                <p className="text-amber-100 text-center text-sm">Short Format – English</p>
              </div>
              <div className="p-6 space-y-4">
                {[
                  "The Distributor shall earn commissions only through the sale of company products.",
                  "The Distributor shall not provide any false information or make misleading promises.",
                  "The Distributor must comply with all company training, guidelines, and compliance policies.",
                  "Commissions shall be paid strictly based on Product Sales and Business Volume (BV).",
                  "In case of any dispute, the decision of the company shall be final and binding."
                ].map((clause, index) => (
                  <div key={index} className="flex items-start space-x-3 bg-gray-700/50 rounded-lg p-4 hover:bg-gray-700 transition-colors duration-300">
                    <div className="flex-shrink-0 w-8 h-8 bg-amber-500 rounded-full flex items-center justify-center font-bold text-gray-900">
                      {index + 1}
                    </div>
                    <p className="text-gray-200 leading-relaxed">{clause}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Important Notice */}
            <div className="bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4 mt-6">
              <div className="flex">
                <div className="flex-shrink-0">
                  <svg className="h-5 w-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="ml-3">
                  <p className="text-sm text-blue-700">
                    By signing this agreement, the Distributor acknowledges that they have read, understood, and agree to abide by all the terms and conditions mentioned above.
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Acceptance Footer */}
        <div className="mt-12 pt-8 border-t-2 border-gray-200 text-center">
          <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
            <p className="text-gray-600 mb-4">
              By proceeding with registration or product purchase, you acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions and the Distributor Agreement.
            </p>
            <button className="bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold px-8 py-3 rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 transform hover:scale-105 shadow-md">
              I Agree to Terms & Conditions
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;